/*
 *
 * OtpErrorToast
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 20-Jan-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantToastMessage from '@nexidigital/merchanttoastmessage'
import './OtpErrorToast.scss'
import { otpErrorMapping } from './OtpErrorMapping'
import { nullSafe } from 'Utility/globalMethods'

const OtpErrorToast = (props) =>
  <Toggle>
    <div className='OtpErrorToast'>
      <MerchantToastMessage
        severity={props.severity}
        label={nullSafe(() => otpErrorMapping[props.type].label, '')}
        icon={false}
        onClose={() => {
          props.actions.doHideToast()
        }}
        duration={props.duration}
      />
    </div>
  </Toggle>

OtpErrorToast.propTypes = {
  actions: PropTypes.object,
  type: PropTypes.string,
  severity: PropTypes.string,
  duration: PropTypes.number
}

OtpErrorToast.defaultProps = {
  actions: {},
  type: '',
  severity: 'error',
  duration: 15000
}

export default OtpErrorToast
